import { makeCall } from "./client";

export class ImportsAPI {

  public importFile(importType: string, fileData: any): Promise<any> {
    return makeCall("post", `imports/${importType}`, fileData, {asMultipartFile: true});
  }

}